import { Heading, Paragraph } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";

export const AvbestillHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <Heading data-size={"lg"} level={1}>
        {t("pages.avtaler.avbestilling.tittel")}
      </Heading>
      <Paragraph>{t("pages.avtaler.avbestilling.beskrivelse")}</Paragraph>
    </div>
  );
};
